// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accountPublicKey[data-v-214db0a2]{display:grid;grid-auto-flow:column;grid-auto-columns:-webkit-max-content;grid-auto-columns:max-content}.value[data-v-214db0a2]{display:inline;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);
// Exports
module.exports = exports;
